import { ReactNode, useContext } from "react";
import Form from "../../formcontrols/Form";
import EditIcon from "../../icons/EditIcon";
import { Modal, ModalContext } from "../Modal";

const ModalCustom = ({
  config,
  title,
  method,
  invalidateData,
  treatAsPatch,
  icon,
}: {
  config: FormConfig<any>;
  title: string;
  method: FormMethod;
  invalidateData?: InvalidateDataFunction<any>;
  treatAsPatch?: boolean;
  icon?: ReactNode;
}) => {
  const { setModalOpen } = useContext(ModalContext);
  return (
    <Modal
      title={
        <>
          {icon ? icon : <EditIcon height={16} />} {title}
        </>
      }
    >
      <div className="c-modal-container">
        <Form
          config={config}
          method={method}
          onSuccess={async () => {
            setModalOpen(false);
            if (invalidateData) await invalidateData();
          }}
          treatAsPatch={treatAsPatch}
        />
      </div>
    </Modal>
  );
};

export default ModalCustom;
